export const GENDER_TRANSLATIONS: Record<string, Record<string, string>> = {
  women: {
    fr: "femme",
    de: "damen",
    it: "donna",
    es: "mujer",
    pl: "kobiety",
    nl: "dames",
    be: "dames",
    com: "women",
    "co.uk": "women",
    en: "women",
  },
  men: {
    nl: "heren",
    be: "heren",
    de: "herren",
    fr: "homme",
    es: "hombre",
    it: "uomo",
    pl: "mezczyzni",
    en: "men",
    "co.uk": "men",
    com: "men",
  },
  kids: {
    com: "kids",
    en: "kids",
    "co.uk": "kids",
    pl: "dzieci",
    de: "kinder",
    nl: "kids",
    be: "kids",
    fr: "enfant",
    es: "ninos",
    it: "bambini",
  },
};

export const GENDER_CATEGORIES: Record<string, string> = {
  // Women variations
  women: "women",
  femme: "women",
  damen: "women",
  dames: "women",
  donna: "women",
  mujer: "women",
  kobiety: "women",

  // Men variations
  men: "men",
  heren: "men",
  herren: "men",
  homme: "men",
  hombre: "men",
  uomo: "men",
  mezczyzni: "men",

  // Kids variations
  kids: "kids",
  dzieci: "kids",
  kinder: "kids",
  enfant: "kids",
  ninos: "kids",
  bambini: "kids",
};

export const BRAND_GEO_MAP: Record<string, string> = {
  en: "brands",
  pl: "marki",
  be: "merken",
  fr: "marques",
  it: "marchi",
  de: "marken",
  nl: "merken",
  com: "brands",
  us: "brands",
  dk: "maerker",
  se: "varumarken",
  es: "marcas",
  at: "marken",
  "nl-be": "merken",
  "it-it": "marchi",
  "es-es": "marcas",
  "pl-pl": "marki",
  "de-at": "marken",
  "en-gb": "brands",
};
